import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLocalizeMessage, Dropdown } from 'libs.nucleus';
export const useMeasuresColumns = ({ onEdit, onDelete, isEditDisabled = false, isDeleteDisabled = false, }) => {
    const translate = useLocalizeMessage();
    return useMemo(() => [
        {
            header: translate('Name'),
            accessorKey: 'title',
            cell: ({ row }) => _jsx("div", { className: 'font-medium', children: row.original.title }),
        },
        {
            header: translate('Type'),
            accessorKey: 'type',
            cell: ({ row }) => {
                const { type } = row.original;
                // Capitalize first letter
                return type ? type.charAt(0).toUpperCase() + type.slice(1) : '-';
            },
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            cell: ({ row }) => row.original.description || '-',
        },
        {
            id: 'actions',
            size: 50,
            cell: ({ row }) => {
                const dropdownItems = [
                    {
                        id: 'edit',
                        content: translate('Edit'),
                        onClick: () => onEdit(row.original.id),
                        disabled: isEditDisabled,
                    },
                    {
                        id: 'delete',
                        content: translate('Delete'),
                        onClick: () => onDelete(row.original.id),
                        disabled: isDeleteDisabled,
                        destructive: true,
                    },
                ];
                return (_jsx("div", { className: 'flex justify-end', children: _jsx(Dropdown, { variant: 'kebab', position: 'bottom-end', items: dropdownItems }) }));
            },
        },
    ], [translate, onEdit, onDelete, isEditDisabled, isDeleteDisabled]);
};
